import { render, staticRenderFns } from "./ResearchDevelopment.vue?vue&type=template&id=37e4f058&scoped=true&"
import script from "./ResearchDevelopment.vue?vue&type=script&lang=ts&"
export * from "./ResearchDevelopment.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchDevelopment.vue?vue&type=style&index=0&id=37e4f058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4f058",
  null
  
)

export default component.exports